@let okr_page = page();

<div class="page-title">
  <app-company-product-page-identity />
  <button mat-icon-button type="button" class="okr-page-back" aria-label="Volver a OKRs y métricas" (click)="goToOkrAndMetrics()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h1>{{ page_title }}</h1>
  <div class="page-title-actions">
    @if (can_toggle_view()) {
      <mat-button-toggle-group [value]="view()" (change)="setView($event)" name="okr-view">
        <mat-button-toggle value="company">Empresa</mat-button-toggle>
        <mat-button-toggle value="product">Producto</mat-button-toggle>
      </mat-button-toggle-group>
    }
    <button mat-stroked-button type="button" (click)="goToBacklog()">Backlog</button>
  </div>
</div>

@if (okr_page.state === 'loading') {
  <p class="okr-status-text">Cargando OKRs…</p>
} @else if (okr_page.state === 'error') {
  <p class="okr-status-text">No se ha podido cargar la gestión de OKRs.</p>
} @else if (okr_page.state === 'empty_periods') {
  <div class="okr-empty-card">
    <p class="okr-empty-copy">Define el periodo en el que quieres alcanzar tu primer objetivo.</p>
    @if (okr_page.can_manage_periods) {
      <button mat-stroked-button color="accent" type="button" (click)="openCreatePeriodDialog()">Crear periodo</button>
    }
  </div>
} @else if (okr_page.state === 'ready') {
  @if (okr_page.period; as period) {
    <div class="okr-period-navigator">
      <button mat-icon-button type="button" [disabled]="!period.previous_period_id" (click)="goToPreviousPeriod()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="okr-period-box">
        <div class="okr-period-box-header">
          <span class="okr-period-box-side" aria-hidden="true"></span>
          <span class="okr-period-box-title">
            {{ period.title }}
            @if (okr_page.period_date_range_label) {
              <span class="okr-period-box-dates">{{ okr_page.period_date_range_label }}</span>
            }
          </span>
          <span class="okr-period-box-side okr-period-box-actions">
            @if (period.status === CompanyObjectivePeriodStatus.Future && okr_page.permissions?.can_manage_periods) {
              <button
                mat-icon-button
                type="button"
                class="small-icon-button"
                [matMenuTriggerFor]="period_menu"
                aria-label="Acciones del periodo"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #period_menu="matMenu">
                <button mat-menu-item type="button" (click)="openEditPeriodDialog()">Editar fechas</button>
                <button mat-menu-item type="button" (click)="deletePeriod()">Eliminar periodo</button>
              </mat-menu>
            }
          </span>
        </div>
        @if (period.status === CompanyObjectivePeriodStatus.Active) {
          <div class="okr-period-progress">
            <div class="okr-period-progress-fill" [style.width.%]="okr_page.period_progress_pct"></div>
          </div>
        }
      </div>
      @if (period.next_period_id) {
        <button mat-icon-button type="button" (click)="goToNextPeriod()" aria-label="Periodo siguiente">
          <mat-icon>chevron_right</mat-icon>
        </button>
      } @else if (okr_page.permissions?.can_manage_periods) {
        <button
          mat-mini-fab
          color="accent"
          type="button"
          class="okr-period-add"
          (click)="openCreatePeriodDialog()"
          aria-label="Crear periodo"
          matTooltip="Crear el siguiente periodo OKR de la empresa (trimestre, año o rango personalizado)"
        >
          <mat-icon>add</mat-icon>
        </button>
      } @else {
        <button mat-icon-button type="button" disabled aria-hidden="true">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
      <span class="okr-period-status">{{ okr_page.period_status_label }}</span>
    </div>

    <div class="okr-tree">
      <div class="okr-tree-node">
        <span class="okr-pill">
          <img class="okr-pill-logo" [src]="company_logo_url()" [alt]="" />
          {{ okr_page.company_name }}
        </span>
        <div class="okr-tree-stem"></div>

        @if (okr_page.company_objective; as company_objective) {
          @if (okr_page.company_objective_card; as company_objective_card) {
            <app-company-product-objective
              [objective]="company_objective_card"
              layout="management"
              [period_status]="period.status"
              [timeline_progress]="period.timeline_progress"
              level_label="Company Objective"
              [selected]="okr_page.expanded === 'company'"
              [clickable]="true"
              [can_update]="company_objective.can_update"
              [can_delete]="company_objective.can_delete"
              [warnings]="okr_page.company_objective_warnings ?? []"
              (cardClick)="toggleCompanyCard()"
              (view)="openViewObjective(company_objective)"
              (edit)="openEditObjective(company_objective)"
              (delete)="deleteObjective(company_objective)"
            />
          }
        } @else {
          <div class="okr-empty-objective">
            @if (okr_page.can_create_company_objective) {
              <button mat-stroked-button type="button" (click)="openCreateCompanyObjective()">+ Añadir objetivo de empresa</button>
            } @else {
              <p>Sin objetivo de empresa</p>
            }
          </div>
        }

        @if (!okr_page.show_product_branch) {
          @if (okr_page.company_objective; as company_objective) {
            <div class="okr-tree-stem"></div>
            @if (okr_page.can_create_company_key_result) {
              <button
                mat-mini-fab
                color="accent"
                type="button"
                class="okr-add-node"
                matTooltip="Añadir Key Result al objetivo de empresa"
                aria-label="Añadir Key Result al objetivo de empresa"
                (click)="openCreateKeyResult(company_objective)"
              >
                <mat-icon>add</mat-icon>
              </button>
              <div class="okr-tree-stem"></div>
            }
            <div class="okr-kr-row">
              @for (key_result of okr_page.company_key_results; track key_result.id) {
                <app-company-objective-key-result
                  [key_result]="key_result"
                  [company_product_id]="company_product_id"
                  layout="management"
                  [period_status]="period.status"
                  [timeline_progress]="period.timeline_progress"
                  [show_options]="true"
                  [can_update]="company_objective.can_update"
                  [can_delete]="company_objective.can_delete"
                  (edit)="openEditKeyResult(company_objective, key_result)"
                  (delete)="deleteKeyResult(key_result)"
                  (variable_condition_updated)="onVariableConditionUpdated()"
                />
              }
            </div>
          }
        }

        @if (okr_page.show_product_branch) {
          <div class="okr-tree-stem"></div>
          <span class="okr-pill">Product Level</span>

          @if (show_product_objective_plus()) {
            <div class="okr-tree-stem"></div>
            <button
              mat-mini-fab
              color="accent"
              type="button"
              class="okr-add-node"
              matTooltip="Añadir objetivo de producto"
              aria-label="Añadir objetivo de producto"
              (click)="openCreateProductObjective()"
            >
              <mat-icon>add</mat-icon>
            </button>
          }

          @if (okr_page.product_objective_cards && okr_page.product_objective_cards.length > 0) {
            <div class="okr-tree-stem"></div>
            <div class="okr-product-row">
              @for (product_objective_card of okr_page.product_objective_cards; track product_objective_card.objective.id) {
                <app-company-product-objective
                  [objective]="product_objective_card.card"
                  layout="management"
                  [period_status]="period.status"
                  [timeline_progress]="period.timeline_progress"
                  [level_label]="'Producto: ' + (product_objective_card.objective.company_product_name ?? '')"
                  [selected]="okr_page.expanded === product_objective_card.objective.id"
                  [clickable]="true"
                  [can_update]="product_objective_card.objective.can_update"
                  [can_delete]="product_objective_card.objective.can_delete"
                  [warnings]="product_objective_card.warnings"
                  (cardClick)="toggleProductCard(product_objective_card.objective.id)"
                  (view)="openViewObjective(product_objective_card.objective)"
                  (edit)="openEditObjective(product_objective_card.objective)"
                  (delete)="deleteObjective(product_objective_card.objective)"
                />
              }
            </div>
          }

          @if (okr_page.expanded_product; as expanded_product) {
            <div class="okr-tree-stem"></div>
            @if (okr_page.can_create_product_key_result) {
              <button
                mat-mini-fab
                color="accent"
                type="button"
                class="okr-add-node"
                matTooltip="Añadir Key Result al objetivo de producto"
                aria-label="Añadir Key Result al objetivo de producto"
                (click)="openCreateKeyResult(expanded_product)"
              >
                <mat-icon>add</mat-icon>
              </button>
              <div class="okr-tree-stem"></div>
            }
            <div class="okr-kr-row">
              @for (key_result of okr_page.product_key_results; track key_result.id) {
                <app-company-objective-key-result
                  [key_result]="key_result"
                  [company_product_id]="company_product_id"
                  layout="management"
                  [period_status]="period.status"
                  [timeline_progress]="period.timeline_progress"
                  [show_options]="true"
                  [can_update]="expanded_product.can_update"
                  [can_delete]="expanded_product.can_delete"
                  (edit)="openEditKeyResult(expanded_product, key_result)"
                  (delete)="deleteKeyResult(key_result)"
                  (variable_condition_updated)="onVariableConditionUpdated()"
                />
              }
            </div>
          }
        }
      </div>
    </div>
  }
}
